export default __webpack_public_path__ + "static/media/bullhill.5143e91f.jpg";